<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <el-row>
                  <el-col :span="12">
                    <span class="cs-title">课程推荐列表</span>
                  </el-col>
                  <el-col :span="12"></el-col>
                </el-row>
                <el-row class="cs-filter-row">
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="5">
                        <el-input
                          placeholder="按号码搜索"
                          size="medium"
                          clearable
                          suffix-icon="el-icon-search"
                          v-model.trim="searchCondition.phone"
                          @change="onSearchConditionChanged"
                        ></el-input>
                      </el-col>
                      <el-col :span="5">
                        <el-select
                          placeholder="大学"
                          v-model="searchCondition.universityId"
                          @change="onUniversityChange"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in universityList"
                            :key="item.Key"
                            :label="item.Value"
                            :value="item.Key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5">
                        <el-select
                          placeholder="登记状态"
                          v-model="searchCondition.isConfigured"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in configurations"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5">
                        <el-select
                          placeholder="学生类型"
                          v-model="searchCondition.isAuld"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in studentTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row class="margin-top-10">
                      <el-col :span="5">
                        <el-select
                          placeholder="报课状态"
                          v-model="searchCondition.isEnroll"
                          @change="onSearchConditionChanged"
                          size="medium"
                        >
                          <el-option
                            v-for="item in applyCourseStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5">
                        <el-select
                          placeholder="课程类型"
                          v-model="searchCondition.courseType"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in courseTypeList"
                            :key="item.Key"
                            :label="item.Value"
                            :value="item.Key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5">
                        <el-select
                          placeholder="所有课程"
                          filterable
                          v-model="searchCondition.courseCode"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in courseCodeList"
                            :key="item.Key"
                            :label="item.Value"
                            :value="item.Key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="5"
                        v-if="
                          searchCondition.courseType == 2 ||
                            searchCondition.courseType == 3
                        "
                      >
                        <el-select
                          v-if="searchCondition.courseType == 2"
                          placeholder="业务"
                          v-model="searchCondition.englishCategoryId"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in englishCategoryList"
                            :key="item.Id"
                            :label="item.Name"
                            :value="item.Id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-if="searchCondition.courseType == 3"
                          placeholder="业务"
                          v-model="searchCondition.trainingCategoryId"
                          @change="onTrainingCategoryChange"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in trainingCategoryList"
                            :key="item.Id"
                            :label="item.Name"
                            :value="item.Id"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5" v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager">
                        <el-select
                          v-show="searchCondition.courseType == 1"
                          placeholder="学期"
                          v-model="searchCondition.termId"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in termList"
                            :key="item.Id"
                            :label="item.DisplayLable"
                            :value="item.Id"
                          ></el-option>
                        </el-select>
                        <el-select
                          v-show="
                            searchCondition.courseType == 3 &&
                              !!searchCondition.trainingCategoryId
                          "
                          placeholder="学期"
                          v-model="searchCondition.trainingTermId"
                          @change="onSearchConditionChanged"
                          size="medium"
                          class="margin-left-20px"
                        >
                          <el-option
                            v-for="item in trainingTermList"
                            :key="item.Id"
                            :label="item.DisplayLable"
                            :value="item.Id"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" v-if="USERMANAGER.isAdmin && !!searchCondition.courseCode">
                        <el-button type="primary"  class="margin-left-20px" size="medium" @click="sendRecommendCourse">推送课程</el-button>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <hr />

                <el-row class="grid-content">
                  <el-col>
                    <el-table
                      v-loading="loading"
                      :data="studentList"
                      :cell-class-name="cellStyle"
                      :header-row-class-name="'el-table-header'"
                    >
                      <el-table-column prop="Phone" label="电话号码" width="120">
                        <template slot-scope="scope">
                          <div>
                            <!--<span class="cs-studentList-Phone" @click="showStudentProfile(scope.row)">
                                            {{scope.row.Phone}}
                            </span>-->
                            <span
                              v-if="USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isRegionCEO"
                              class="cs-studentList-Phone"
                              @click="showStudentProfile(scope.row)"
                            >{{ scope.row.Phone }}</span>
                            <span
                              v-if="!(USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isRegionCEO)"
                              class="cs-studentList-Phone"
                            >{{ hidePhoneNumber(scope.row.Phone) }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="UniversityName" label="所属大学" width="100"></el-table-column>
                      <el-table-column prop="SpeedupCourseNames" label="报名课程" width="300"></el-table-column>
                      <el-table-column prop="StudentCourseNames" label="在校课程" width="150"></el-table-column>
                      <el-table-column prop="CourseSuggestionNames" label="推荐课程" width="150"></el-table-column>
                      <el-table-column prop="IsConfigured" label="登记在校课程" width="150">
                        <template slot-scope="scope">
                          <div>
                            <span v-if="scope.row.IsConfigured">是</span>
                            <el-button
                              :class="{
                                'margin-left-20px': true,
                                isClicked: checkIsClicked(scope.$index)
                              }"
                              v-if="scope.row.IsConfigured"
                              size="medium"
                              type="text"
                              @click="
                                showStudentCourseSchedule(
                                  scope.$index,
                                  scope.row
                                )
                              "
                            >查看</el-button>
                            <span v-if="!scope.row.IsConfigured">否</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="IsMember" label="会员类型" width="100">
                        <template slot-scope="scope">
                          <div>
                            <span v-if="scope.row.IsMember">会员</span>
                            <span v-if="!scope.row.IsMember">非会员</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="IsMember" label="学生类型" width="100">
                        <template slot-scope="scope">
                          <div>
                            <span v-if="scope.row.IsAuld">非新生</span>
                            <span v-if="!scope.row.IsAuld">新生</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="BonusPoint" label="积分" width="80"></el-table-column>
                      <el-table-column prop="Balance" label="余额" width="80">
                        <template slot-scope="scope">
                          <div>
                            <span>{{ scope.row.Balance | toCurrency }}</span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="AdvanceEnrollmentCount" label="大学占位" width="80">
                        <template slot-scope="scope">
                          <div>
                            <span>
                              {{ scope.row.AdvanceEnrollmentCount }}({{
                              scope.row.AdvanceEnrollmentCount -
                              scope.row.AdvanceEnrollmentCountUsed
                              }})
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="TrainingAdvanceEnrollmentCount"
                        label="职业培训占位"
                        width="80"
                      >
                        <template slot-scope="scope">
                          <div>
                            <span>
                              {{ scope.row.TrainingAdvanceEnrollmentCount }}({{
                              scope.row.TrainingAdvanceEnrollmentCount -
                              scope.row.TrainingAdvanceEnrollmentCountUsed
                              }})
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[20, 50, 100]"
                      :page-size="20"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="recordTotal"
                    ></el-pagination>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="在校课程时间表"
      class="cs-studentCourseReview" 
      :center="true"
      :close-on-click-modal="false"
      width="70%"
      :visible.sync="displayStudentCourse"
      top="5vh"
    >
      <studentCourseReview
        :data="currentStudentData"
        @close="closeStudentCourse"
        v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"
      ></studentCourseReview>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-studentCourseReview{
    padding-left: 40px;
    padding-right: 40px;
}

body .cs-filter-row {
  padding-top: 10px;
}
.cs-contentContainer {
  .grid-content {
    margin-top: 15px;

    .cs-schedule-buttonContainer {
      text-align: right;
    }

    .cs-studentList-Phone {
      color: #409eff;
      cursor: pointer;
    }
  }

  .cs-schedule-bottomButton {
    margin-top: 20px;
  }

  .disable-all-button {
    color: #fff;
    background-color: rgba(230, 66, 70, 80%);
    border-color: rgba(230, 66, 70, 80%);
  }

  .disable-all-button:hover {
    background-color: rgba(230, 66, 70, 100%);
    border-color: rgba(230, 66, 70, 100%);
  }

  .enable-all-button {
    color: #fff;
    background-color: rgb(179, 52, 60);
    border-color: rgb(179, 52, 60);
  }

  .enable-all-button:hover {
    background-color: rgba(230, 66, 70, 100%);
    border-color: rgba(230, 66, 70, 100%);
  }
}
</style>

<script>
import {
  getUniversities,
  getTerms,
  getTrainingTerms,
  getTrainingCategoryList,
  getCourseCodeListByUniversityId
} from "../../service/common.service";
import { getCourseTypeList } from "../../config/mUtils";
import {
  getStudentSpeedupCourse,
  sendRecommendNotifications
} from "../../service/student.service";
import navigator from "../../components/navigator";
import fileUploader from "../../components/fileHandler/fileUploader";
import phoneEditorVue from "../../components/phoneEditor.vue";
import studentCourseReview from "../../components/studentCourseReview.vue";
export default {
  data() {
    getUniversities().then(result => {
      if (!!result && result.success) {
        this.universityList = this.universityList.concat(result.data);
      }
    });
    return {
      currentStudentData: {},
      displayStudentCourse: false,
      currentPageSize: 20,
      recordTotal: 0,
      currentPage: 1,
      loading: false,
      isDisableLoading: false,
      isEnableLoading: false,
      fileUploaderVisible: false,
      fileUploaderCloseVisible: true,
      universityList: [
        {
          Key: "",
          Value: "所有学校"
        }
      ],
      configurations: [
        {
          value: "",
          label: "不限登记状态"
        },
        {
          value: false,
          label: "未登记"
        },
        {
          value: true,
          label: "已登记"
        }
      ],
      enrollList: [
        {
          value: "",
          label: "不限报名状态"
        },
        {
          value: false,
          label: "未报名"
        },
        {
          value: true,
          label: "已报名"
        }
      ],
      studentTypeList: [
        {
          value: "",
          label: "不限学生类型"
        },
        {
          value: false,
          label: "新生"
        },
        {
          value: true,
          label: "非新生"
        }
      ],
      applyCourseStatus: [
        {
          value: "",
          label: "不限报课状态"
        },
        {
          value: true,
          label: "已报课"
        },
        {
          value: false,
          label: "未报课"
        }
      ],
      searchCondition: {
        phone: "",
        universityId: "",
        isConfigured: "",
        isEnroll: "",
        termId: "",
        isAuld: "",
        isApplyCourse: "",
        courseType: "",
        trainingTermId: "",
        trainingCategoryId: "",
        englishCategoryId: "",
        courseCode: ""
      },
      studentList: [],
      clickedStudentList: [],
      currentTermId: 0,
      termList: [],
      studentFinancialSummary: {},
      courseTypeList: [],
      trainingTermList: [],
      trainingCategoryList: [],
      englishCategoryList: [],
      courseCodeList: []
    };
  },
  components: {
    navigator,
    fileUploader,
    studentCourseReview
  },
  computed: {},
  created() {
    this.courseTypeList = getCourseTypeList();
    this.courseTypeList.splice(0, 0, { Key: 0, Value: "所有类型" });
    this.searchCondition.courseType = 0;

    this.loadStudentSpeedupCourse();
    //this.loadStudentFinacialSummary();
    getTerms(true).then(result => {
      if (!!result && result.success) {
        this.termList = result.data;
        let currentTerm = result.data.find(i => i.IsCurrentTerm);
        if (!!currentTerm) {
          this.searchCondition.termId = currentTerm.Id;
        }
      }
    });
    getTrainingCategoryList(3).then(result => {
      if (!!result && result.success) {
        this.trainingCategoryList = result.data;
        this.trainingCategoryList.splice(0, 0, {
          Id: 0,
          Name: "所有业务"
        });
        this.searchCondition.trainingCategoryId = 0;
      }
    });
    getTrainingCategoryList(2).then(result => {
      if (!!result && result.success) {
        this.englishCategoryList = result.data;
        this.englishCategoryList.splice(0, 0, {
          Id: 0,
          Name: "所有业务"
        });
        this.searchCondition.englishCategoryId = 0;
      }
    });
    this.loadCourseCode();
  },
  methods: {
    loadTrainingTermList(callback) {
      if (!this.searchCondition.trainingCategoryId) {
        if (callback) {
          callback();
        }
        return;
      }
      getTrainingTerms(true, this.searchCondition.trainingCategoryId).then(
        result => {
          if (!!result && result.success) {
            this.trainingTermList = result.data;
            let currentTerm = result.data.find(i => i.IsCurrentTerm);
            if (!!currentTerm) {
              this.searchCondition.trainingTermId = currentTerm.Id;
              if (callback) {
                callback();
              }
              return;
            }
          }
        }
      );
    },
    onTrainingCategoryChange() {
      this.loadTrainingTermList(() => {
        this.onSearchConditionChanged();
      });
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    getSearchConditions() {
      let conditions = {
        phone: this.searchCondition.phone,
        universityId: this.searchCondition.universityId,
        isConfigured: this.searchCondition.isConfigured,
        isEnroll: this.searchCondition.isEnroll,
        isAuld: this.searchCondition.isAuld,
        isApplyCourse: this.searchCondition.isApplyCourse,
        courseType: this.searchCondition.courseType,
        courseCode: this.searchCondition.courseCode,
        termId: "",
        categoryId: ""
      };
      if (this.searchCondition.courseType == 1) {
        conditions.termId = this.searchCondition.termId;
      } else if (this.searchCondition.courseType == 2) {
        conditions.categoryId = this.searchCondition.englishCategoryId;
      } else {
        conditions.termId = this.searchCondition.trainingTermId;
        conditions.categoryId = this.searchCondition.trainingCategoryId;
      }
      return conditions;
    },
    loadStudentSpeedupCourse() {
      this.loading = true;
      let conditions = this.getSearchConditions();

      getStudentSpeedupCourse(
        conditions,
        this.currentPage,
        this.currentPageSize,
        "Phone",
        true
      ).then(result => {
        if (!!result && result.success) {
          this.studentList = result.data.PageList;
          this.recordTotal = result.data.RecordTotal;
          this.clickedStudentList = [];
          this.studentList.forEach(element => {
            this.clickedStudentList.push(false);
          });
        }
        this.loading = false;
      });
    },
    onUniversityChange() {
      this.loadCourseCode();
      this.onSearchConditionChanged();
      //this.loadStudentFinacialSummary();
    },
    onSearchConditionChanged() {
      this.currentPage = 1;
      this.loadStudentSpeedupCourse();
    },
    handleSizeChange(value) {
      this.currentPageSize = value;
      this.currentPage = 1;
      this.loadStudentSpeedupCourse();
    },
    handleCurrentChange(index) {
      this.currentPage = index;
      this.loadStudentSpeedupCourse();
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    checkIsClicked(index) {
      return this.clickedStudentList[index];
    },
    showStudentCourseSchedule(index, row) {
      let list = [];
      this.clickedStudentList.forEach(element => {
        list.push(element);
      });
      list[index] = true;
      this.clickedStudentList = list;

      row.isClicked = true;
      this.currentStudentData = {
        termId: this.searchCondition.termId,
        studentId: row.StudentId,
        phone: row.Phone,
        universityName: row.UniversityName,
        speedupCourse: row.SpeedupCourseNames,
        universityId: row.UniversityId
      };
      this.displayStudentCourse = true;
      // this.$router.push({
      //   path: "/admin/studentCourseReview",
      //   query: {
      //     studentId: row.StudentId,
      //     phone: row.Phone,
      //     universityName: row.UniversityName,
      //     speedupCourse: row.SpeedupCourseNames
      //   }
      // });
    },
    loadCourseCode() {
      this.searchCondition.courseCode = "";
      getCourseCodeListByUniversityId(this.searchCondition.universityId).then(
        result => {
          if (!!result && result.success) {
            this.courseCodeList = result.data;
            this.courseCodeList.splice(0, 0, {
              Key: "",
              Value: "所有课程"
            });
          }
        }
      );
    },
    showStudentProfile(row) {
      //debugger;
      this.$router.push({
        path: "/studentProfile",
        query: {
          studentId: row.StudentId
        }
      });
    },

    importStudents() {
      this.fileUploaderVisible = true;
    },
    hidePhoneNumber(phone) {
      if (phone.length == 6){
        return phone;
      }
      if (phone.length> 6){
        return phone.substring(phone.length - 6, phone.length);
      }
      return phone;
    },
    sendRecommendCourse() {
      if (!!this.searchCondition.courseCode) {
        this.$confirm(
          "您确定要推送 " +
            this.searchCondition.courseCode +
            " 这门课程推荐吗？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            sendRecommendNotifications(this.searchCondition.courseCode).then(
              result => {
                if (!!result && result.success) {
                  this.$message.success("推送推荐课程成功!");
                } else {
                  this.$message.error("推送推荐课程失败!");
                }
              }
            );
          })
          .catch(() => {
       
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/studentCourseSuggestionList.vue